import {validateValue} from '../helpers/validation'

// Begin action types
export const SET_SKILLVENDOR_SEARCH_DROPDOWN_OPTIONS = 'SET_SKILLVENDOR_SEARCH_DROPDOWN_OPTIONS'
export const SET_SKILLVENDOR_SEARCH_CHECKBOX_VALUE = 'SET_SKILLVENDOR_SEARCH_CHECKBOX_VALUE'
export const CLEAR_SKILLVENDOR_SEARCH_FIELDS = 'CLEAR_SKILLVENDOR_SEARCH_FIELDS'
export const VALIDATE_SKILLVENDOR_SEARCH_FIELD = 'VALIDATE_SKILLVENDOR_SEARCH_FIELD'

export const CLEAR_SKILLVENDOR = 'CLEAR_SKILLVENDOR'
export const FETCH_SKILLVENDOR_OVERVIEW_SUCCESS = 'FETCH_SKILLVENDOR_OVERVIEW_SUCCESS'
export const FETCH_SKILLVENDOR_PROFILE_SUCCESS = 'FETCH_SKILLVENDOR_PROFILE_SUCCESS'
export const CLEAR_SKILLVENDOR_CURRENT_PROFILE = 'CLEAR_SKILLVENDOR_CURRENT_PROFILE'
export const FETCH_SKILLVENDOR_PRODUCTIONS_SUCCESS = 'FETCH_SKILLVENDOR_PRODUCTIONS_SUCCESS'
export const FETCH_SKILLVENDOR_POINTS_SUCCESS = 'FETCH_SKILLVENDOR_POINTS_SUCCESS'
export const FETCH_SKILLVENDOR_DEVICES_SUCCESS = 'FETCH_SKILLVENDOR_DEVICES_SUCCESS'
export const FETCH_SKILLVENDOR_HISTORY_PROFILE_STATUSES_SUCCESS = 'FETCH_SKILLVENDOR_HISTORY_PROFILE_STATUSES_SUCCESS'

export const FETCH_SKILLVENDOR_EDIT_DATA_SUCCESS = 'FETCH_SKILLVENDOR_EDIT_DATA_SUCCESS'
export const VALIDATE_SKILLVENDOR_EDIT_FIELD = 'VALIDATE_SKILLVENDOR_EDIT_FIELD'
export const SUBMIT_SKILLVENDOR_EDIT_FIELDS = 'SUBMIT_SKILLVENDOR_EDIT_FIELDS'
export const CLEAR_SKILLVENDOR_EDIT_FIELDS = 'CLEAR_SKILLVENDOR_EDIT_FIELDS'
// End action types

export const setSkillVendorSearchDropdownOptions = (skillTypes, skillLevels, ageFromList, ageToList, city,schools, nativeLanguage, experience, remoteRecordingCapability,
   gender, skillVendorStatus, numberOfAdaptionsRange, numberOfSongsWrittenRange, numberOfTranslationsRange, universityDegree, vocalRange, musicNotesReadingLevel,
    voiceAgeRange, country, ethnicity, identity, voiceType, languageAccent, union, region, remoteRecordingDirector, remoteRecordingListLyricist,
  remoteRecordingListVoiceActor, remoteRecordingListSinger, remoteRecordingEditor, remoteRecordingListSoundEngineer, universityDegreeListAdaptor,
universityDegreeListLyricist, voiceAgeRangeListSinger, unionListSinger, directorAppAccess) => ({
  type: SET_SKILLVENDOR_SEARCH_DROPDOWN_OPTIONS,
  skillTypes,
  skillLevels,
  ageFromList,
  ageToList,
  city,
  schools,
  nativeLanguage,
  experience,
  remoteRecordingCapability,
  gender,
  skillVendorStatus,
  numberOfAdaptionsRange,
  numberOfSongsWrittenRange,
  numberOfTranslationsRange,
  universityDegree,
  vocalRange,
  musicNotesReadingLevel,
  voiceAgeRange,
  country,
  ethnicity,
  identity,
  voiceType,
  languageAccent,
  union,
  region,
  remoteRecordingDirector,
  remoteRecordingListLyricist,
  remoteRecordingListVoiceActor,
  remoteRecordingListSinger,
  remoteRecordingEditor,
  remoteRecordingListSoundEngineer,
  universityDegreeListAdaptor,
  universityDegreeListLyricist,
  voiceAgeRangeListSinger,
  unionListSinger,
  directorAppAccess
});
export const setSkillVendorSearchCheckboxValue = (knownTalent, doNotUse, skillVendorStatus, liveActionVoiceGenderMale,liveActionVoiceGenderFemale, voiceActorTheatricalExperience,
voiceActorTVExperience,voiceActorVideoGamesExperience,voiceActorPromoOrCommercialsExperience,voiceActorAnimationMaleVoiceGender,voiceActorAnimationFemaleVoiceGender,
voiceActorLiveActionExperience,voiceActorAnimationExperience,voiceActorDubbingExperience,voiceActorAudiobooksExperience, voiceActorVoiceOverExperience,
voiceActorRadioExperience,voiceActorTheatreActorExperience,voiceActorMovieActorExperience,voiceActorAudioDescriptionExperience, bookerTheatricalExperience,
bookerTVExperience, bookerInteractiveExperience, singerMaleVoiceGender, singerFemaleVoiceGender,singerDubbingExperience,singerStageExperience,singerTheatreExperience,
singerTalentShowExperience,  directorTheatricalExperience, directorTVExperience, directorGamesExperience, directorPromoOrCommercialsExperience,
directorLiveActionExperience, directorAnimationExperience, directorDubbingDirectorExperience, directorVoiceOverDirectorExperience, directorSongDirectorExperience,
directorDubbingActorExperience, directorStageDirectorExperience, directorMovieDirectorExperience, directorAudioDescriptionExperience, lyricistMusicalExperience,
lyricistTheatreExperience, lyricistPromoCommercialsExperience, lyricistExperience, lyricistDubbingExperience, lyricistMusicianExperience,
translatorTheatricalExperience, translatorTVExperience, translatorGamesExperience, translatorPromoOrCommercialsExperience, translatorLiveActionExperience,
translatorAnimationExperience, translatorSubtitlesExperience, translatorDubbingExperience, translatorVoiceOverExperience, translatorGamingExperience,
translatorAudioDescriptionExperience,translatorHOHSDHCCExperience, editorDubbingExperience, editorVoiceOverExperience, editorSongsExperience, editorProToolsExperience,
editorDolby51Experience, editorAtmosExperience, editorFoleyExperience, editorRecordingEditingExperience, editorDialogueEditingExperience, editorMusicAndEffectsExperience,
editorMixEditingExperience, editorPreparingTakesExperience, editorAudioDescriptionExperience, adaptorTheatricalExperience,adaptorTVExperience, adaptorGamesExperience,
adaptorPromoOrCommercialsExperience, adaptorLiveActionExperience, adaptorAnimationExperience, adaptorAdaptorExperience, adaptorDubbingDirectorExperience,
adaptorTranslatorExperience, adaptorVoiceActorExperience, adaptorAudioDescriptionExperience, soundEngineerDubbingExperience, soundEngineerVoiceOverExperience, soundEngineerSongsExperience,
soundEngineerProToolsExperience,soundEngineerDolby51Experience,soundEngineerAtmosExperience,soundEngineerFoleyExperience,soundEngineerDialogueRecordingExperience,
soundEngineerSongRecordingExperience,soundEngineerDialogueMixingExperience,soundEngineerSongMixingExperience,soundEngineerAudioDescriptionMixingExperience,
singerGenderNeutralVoice, voiceActorGenderNeutralVoice, adaptorDoNotUse, bookerDoNotUse, directorDoNotUse, editorDoNotUse, lyricistDoNotUse, singerDoNotUse,
soundEngineerDoNotUse, translatorDoNotUse, voiceActorDoNotUse,skillVendorStatusCheckbox ) => ({
  type: SET_SKILLVENDOR_SEARCH_CHECKBOX_VALUE,
  knownTalent,
  doNotUse,
  skillVendorStatus,
  liveActionVoiceGenderMale,
  liveActionVoiceGenderFemale,
  voiceActorTheatricalExperience,
  voiceActorTVExperience,
  voiceActorVideoGamesExperience,
  voiceActorPromoOrCommercialsExperience,
  voiceActorAnimationMaleVoiceGender,
  voiceActorAnimationFemaleVoiceGender,
  voiceActorLiveActionExperience,
  voiceActorAnimationExperience,
  voiceActorDubbingExperience,
  voiceActorAudiobooksExperience,
  voiceActorVoiceOverExperience,
  voiceActorRadioExperience,
  voiceActorTheatreActorExperience,
  voiceActorMovieActorExperience,
  voiceActorAudioDescriptionExperience,
  bookerTheatricalExperience,
  bookerTVExperience,
  bookerInteractiveExperience,
  singerMaleVoiceGender,
  singerFemaleVoiceGender,
  singerDubbingExperience,
  singerStageExperience,
  singerTheatreExperience,
  singerTalentShowExperience,
  directorTheatricalExperience,
  directorTVExperience,
  directorGamesExperience,
  directorPromoOrCommercialsExperience,
  directorLiveActionExperience,
  directorAnimationExperience,
  directorDubbingDirectorExperience,
  directorVoiceOverDirectorExperience,
  directorSongDirectorExperience,
  directorDubbingActorExperience,
  directorStageDirectorExperience,
  directorMovieDirectorExperience,
  directorAudioDescriptionExperience,
  lyricistMusicalExperience,
  lyricistTheatreExperience,
  lyricistPromoCommercialsExperience,
  lyricistExperience,
  lyricistDubbingExperience,
  lyricistMusicianExperience,
  translatorTheatricalExperience,
  translatorTVExperience,
  translatorGamesExperience,
  translatorPromoOrCommercialsExperience,
  translatorLiveActionExperience,
  translatorAnimationExperience,
  translatorSubtitlesExperience,
  translatorDubbingExperience,
  translatorVoiceOverExperience,
  translatorGamingExperience,
  translatorAudioDescriptionExperience,
  translatorHOHSDHCCExperience,
  editorDubbingExperience,
  editorVoiceOverExperience,
  editorSongsExperience,
  editorProToolsExperience,
  editorDolby51Experience,
  editorAtmosExperience,
  editorFoleyExperience,
  editorRecordingEditingExperience,
  editorDialogueEditingExperience,
  editorMusicAndEffectsExperience,
  editorMixEditingExperience,
  editorPreparingTakesExperience,
  editorAudioDescriptionExperience,
  adaptorTheatricalExperience,
  adaptorTVExperience,
  adaptorGamesExperience,
  adaptorPromoOrCommercialsExperience,
  adaptorLiveActionExperience,
  adaptorAnimationExperience,
  adaptorAdaptorExperience,
  adaptorDubbingDirectorExperience,
  adaptorTranslatorExperience,
  adaptorVoiceActorExperience,
  adaptorAudioDescriptionExperience,
  soundEngineerDubbingExperience,
  soundEngineerVoiceOverExperience,
  soundEngineerSongsExperience,
  soundEngineerProToolsExperience,
  soundEngineerDolby51Experience,
  soundEngineerAtmosExperience,
  soundEngineerFoleyExperience,
  soundEngineerDialogueRecordingExperience,
  soundEngineerSongRecordingExperience,
  soundEngineerDialogueMixingExperience,
  soundEngineerSongMixingExperience,
  soundEngineerAudioDescriptionMixingExperience,
  singerGenderNeutralVoice,
  voiceActorGenderNeutralVoice,
  adaptorDoNotUse,
  bookerDoNotUse,
  directorDoNotUse,
  editorDoNotUse,
  lyricistDoNotUse,
  singerDoNotUse,
  soundEngineerDoNotUse,
  translatorDoNotUse,
  voiceActorDoNotUse,
  skillVendorStatusCheckbox
});
export const clearSkillVendorSearchFields = () => ({
  type: CLEAR_SKILLVENDOR_SEARCH_FIELDS
});
export const validateSkillVendorSearchField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_SKILLVENDOR_SEARCH_FIELD,
    field
  }
}

export const clearSkillVendor = () => ({
  type: CLEAR_SKILLVENDOR
});
export const fetchSkillVendorOverviewSuccess = (overview) => ({
  type: FETCH_SKILLVENDOR_OVERVIEW_SUCCESS,
  overview
});
export const fetchSkillVendorProfileSuccess = (currentProfile) => ({
  type: FETCH_SKILLVENDOR_PROFILE_SUCCESS,
  currentProfile
});
export const clearSkillVendorCurrentProfile = () => ({
  type: CLEAR_SKILLVENDOR_CURRENT_PROFILE
});
export const fetchSkillVendorProductionsSuccess = (productions) => ({
  type: FETCH_SKILLVENDOR_PRODUCTIONS_SUCCESS,
  productions
});
export const fetchSkillVendorPointsSuccess = (points) => ({
  type: FETCH_SKILLVENDOR_POINTS_SUCCESS,
  points
});
export const fetchSkillVendorDevicesSuccess = (devices) => ({
  type: FETCH_SKILLVENDOR_DEVICES_SUCCESS,
  devices
});
export const fetchSkillVendorHistoryProfileStatusesSuccess = (profileStatuses) => ({
  type: FETCH_SKILLVENDOR_HISTORY_PROFILE_STATUSES_SUCCESS,
  profileStatuses
});

export const fetchSkillVendorEditDataSuccess = (data) => ({
  type: FETCH_SKILLVENDOR_EDIT_DATA_SUCCESS,
  data
});
export const validateSkillVendorEditField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_SKILLVENDOR_EDIT_FIELD,
    field
  }
}
export const submitSkillVendorEditFields = (fields) => {
  return {
    type: SUBMIT_SKILLVENDOR_EDIT_FIELDS,
    fields
  }
}
export const clearSkillVendorEditFields = (fields) => {
  return {
    type: CLEAR_SKILLVENDOR_EDIT_FIELDS
  }
}
